<template style="">
  <div class="Workload_analysis">

    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="综合查询">
        <el-input v-model="formInline.Name" placeholder="账号/姓名/标题查询"></el-input>
      </el-form-item>

      <el-form-item label="统计时间">
        <el-date-picker value-format="yyyy-MM-dd" v-model="formInline.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="primary" @click="resetfun()">重置</el-button>
      </el-form-item>
    </el-form>

    <div style="width: 100%;height: calc(100% - 115px);background-color: #fff;margin-top: 14px;">
      <el-button @click="fanhui()" type="primary" style="margin-left: 1%;margin-top: 14px;">返回</el-button>
      <el-table :data="tableData" style="width: 98%;margin-left: 1%;padding-top: 14px;">
        <el-table-column prop="UserID" label="人员账号" ></el-table-column>
        <el-table-column prop="RealName" label="姓名" ></el-table-column>
        <el-table-column prop="MaterialName" label="标题"></el-table-column>
        <el-table-column prop="MaterialType" label="内容形式"></el-table-column>
        <el-table-column prop="CreatedDate" label="创建时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="re_look(scope.row.MaterialKey, scope.row.MaterialType)">{{scope.row.status == '已驳回'?'驳回原因':'查看'}}</span>
            <span v-if="scope.row.MaterialType=='文章'" style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="Preview(scope.row.MaterialKey)">预览</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange" :current-page.sync="formInline.PageIndex" :page-size="formInline.PageSize" layout="total, prev, pager, next" :total="UndoCount"></el-pagination>
    </div>

    <!-- <el-dialog title="收益配置" :visible.sync="dialogVisible" width="700px" :before-close="handleClose">

      <ul style="overflow: auto;" class="allocation">

        <li>
          <span>当前发布文章收益：<i style="color: red;font-style: normal;">100</i> 元/条</span>
          <span style="float: right;">下月发布文章收益：<el-input style="width: 100px;height: 30px;" v-model="input"></el-input> 元/条</span>
        </li>

        <li>
          <span>当前发布视频收益：<i style="color: red;font-style: normal;">100</i>元/条</span>
          <span style="float: right;">下月发布视频收益：<el-input style="width: 100px;" v-model="input"></el-input> 元/条</span>
        </li>

        <li>
          <span>当前发布音频收益：<i style="color: red;font-style: normal;">100</i>元/条</span>
          <span style="float: right;">下月发布音频收益：<el-input style="width: 100px;" v-model="input"></el-input> 元/条</span>
        </li>

        <li>
          <span>当前发布图片收益：<i style="color: red;font-style: normal;">100</i>元/条</span>
          <span style="float: right;">下月发布图片收益：<el-input style="width: 100px;" v-model="input"></el-input> 元/条</span>
        </li>

        <li>
          <span>当前编辑文章收益：<i style="color: red;font-style: normal;">100</i>元/条</span>
          <span style="float: right;">下月编辑文章收益：<el-input style="width: 100px;" v-model="input"></el-input> 元/条</span>
        </li>
        
      </ul>

    </el-dialog> -->

    <el-dialog
      :visible.sync="dialogVisible"
      width="640px"
      top="10vh"
      :before-close="handleClose">
      <div class="Articlecontent">
        <div v-html="Article"></div>
      </div>
      
    </el-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {
      Article:'',
      formInline: {
        Name: '',
        time: [],
        PageSize: 10,
        PageIndex: 1,
      },
      tableData: [],
      UndoCount: 0,
      dialogVisible: false
    }
  },
  mounted() {
    this.loading();
  },
  methods: {
    resetfun() {
      this.formInline = {
        Name: '',
        time: [],
        PageSize: 10,
        PageIndex: 1,
      }
      this.loading();
    },
    fanhui() {
      this.$router.push({path:'/propagate/Workload_analysis'})
    },
    re_look(materialKey, materialType){//查看
      if (materialType == "音频") {
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 1 ,UserID:[this.$route.query.UserID][0]},
        })
      } else if (materialType == "视频") {
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 2 ,UserID:[this.$route.query.UserID][0]},
        })
      } else if (materialType == "图片") {
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 3 ,UserID:[this.$route.query.UserID][0]},
        })
      }else if(materialType == "文章"){
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: { materialKey: materialKey, Type: 4 ,UserID:[this.$route.query.UserID][0]},
        })
      }
    },
    // 预览
    Preview(materialKey){
      this.dialogVisible=true;
        this.$Http_Post('management/getContentDetails',{MaterialKey:materialKey}).then(res=>{
          if(res.Code==200 || res.Code==0){
            this.dialogVisible=true;
            this.Article=res.Data.richTextContent
          }else{
            this.$message({type: 'error', message:res.Message});
          }
        })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    Income_allocation() {
      this.dialogVisible = true;
    },
    handleCurrentChange(val) {
      this.formInline.PageIndex = val;
      this.loading();
    },
    onSubmit(){
      this.loading();
    },
    loading(){
      this.$Http_Post('management/workStatisticsData', { PageIndex: this.formInline.PageIndex, PageSize: this.formInline.PageSize, StartTime: this.formInline.time[0], EndTime: this.formInline.time[1], Name:this.formInline.Name, Creator: [this.$route.query.UserID][0] }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data;
          this.UndoCount = res.Counts
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    }
  },
}
</script>
<style>
.Workload_analysis{width: 100%;height: 100%;}
.Workload_analysis .demo-form-inline{padding: 20px;background-color: #fff;}
.Workload_analysis .allocation li{margin-top: 14px;width: 100%;height: 40px;font-size: 16px;}
.Workload_analysis .allocation li span{line-height: 40px;}
.Articlecontent{padding: 30px;height: 70vh;overflow-y: auto;}
</style>
